import { sync } from "vuex-pathify";
export default {
  computed: {
    lists: sync("lists/items"),
    currentListId: sync("lists/currentId"),
    currentList: {
      get() {
        return this.lists?.[this.currentListId];
      },
      set(val) {
        this.currentListId = isNaN(val) && val.id ? val.id : val;
      },
    },
  },
};
